import { render, staticRenderFns } from "./SeguroLista.vue?vue&type=template&id=040dcd8e&scoped=true"
import script from "./SeguroLista.vue?vue&type=script&lang=js"
export * from "./SeguroLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040dcd8e",
  null
  
)

export default component.exports